<script>
export default {
  name: 'OutsideAreas',
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<template>
  <main class="page">
    <header>
      <h2>{{ $t('pageOutside.header.title') }}</h2>
      <p>{{ $t('pageOutside.header.p') }}</p>
    </header>
    <section class="gallery">
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto:best,w_347/v1634569688/outside-area/out-5_wmnxqj.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569694/outside-area/out-13_hgbrec.jpg"
          alt=""
        />
      </div>
      <div class="text">
        <p>{{ $t('pageOutside.text.p1') }}</p>
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569689/outside-area/out-15_j17ghz.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569690/outside-area/out-8_ylalzx.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569692/outside-area/out-1_kpobqk.jpg"
          alt=""
        />
      </div>
      <div class="text">
        <p>{{ $t('pageOutside.text.p2') }}</p>
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569687/outside-area/out-19_jilugn.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569695/outside-area/out-11_nvsey8.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569689/outside-area/out-10_nconmp.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569692/outside-area/out-7_wixpgs.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_600/v1634569692/outside-area/out-14_c6oetg.jpg"
          alt=""
        />
      </div>
      <div>
        <img
          src="https://res.cloudinary.com/rizeshouse/image/upload/c_scale,q_auto,w_900/v1634569689/outside-area/out-12_y5ouqy.jpg"
          alt=""
        />
      </div>
    </section>
  </main>
</template>

<style scoped lang="scss">
.page {
  min-height: 100vh;

  background-color: hsl(var(--clr-primary-700));
  color: hsl(var(--clr-primary-100));
}

header {
  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: hsl(var(--clr-primary-500));

  h2 {
    margin-bottom: 20px;
    font-family: var(--ff-serif);
    font-size: var(--fs-7-5);
    font-weight: 200;
    line-height: 20px;
    letter-spacing: 1px;
  }

  p {
    width: 60%;
    font-family: var(--ff-serif);
    font-size: var(--fs-5-4);
    font-weight: 400;
    line-height: 24px;
    text-align: center;
  }
}

.gallery {
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  margin: 1.5rem clamp(1px, -6.2667rem + 17.4074vw, 18.8rem);
  height: 100%;

  background-color: hsl(var(--clr-primary-700));

  display: grid;
  gap: 10px;

  grid-template-areas:
    'pic1 pic1 pic1 pic2 pic2 pic2'
    'pic1 pic1 pic1 pic2 pic2 pic2'
    'pic1 pic1 pic1 pic2 pic2 pic2'
    'pic1 pic1 pic1 pic3 pic3 pic3'
    'pic1 pic1 pic1 pic3 pic3 pic3'
    'pic4 pic4 pic5 pic5 pic6 pic6'
    'pic4 pic4 pic5 pic5 pic6 pic6'
    'pic4 pic4 pic5 pic5 pic6 pic6'
    'pic7 pic7 pic7 pic8 pic8 pic8'
    'pic7 pic7 pic7 pic8 pic8 pic8'
    'pic9 pic9 pic9 pic8 pic8 pic8'
    'pic9 pic9 pic9 pic8 pic8 pic8'
    'pic9 pic9 pic9 pic8 pic8 pic8'
    'pic10 pic10 pic11 pic11 pic12 pic12'
    'pic10 pic10 pic11 pic11 pic12 pic12'
    'pic10 pic10 pic11 pic11 pic12 pic12'
    'pic13 pic13 pic13 pic13 pic13 pic13'
    'pic13 pic13 pic13 pic13 pic13 pic13'
    'pic13 pic13 pic13 pic13 pic13 pic13'
    'pic13 pic13 pic13 pic13 pic13 pic13'
    'pic13 pic13 pic13 pic13 pic13 pic13';

  grid-auto-rows: 100px;

  div:nth-child(1) {
    grid-area: pic1;
  }

  div:nth-child(2) {
    grid-area: pic2;
  }

  div:nth-child(3) {
    grid-area: pic3;
  }

  div:nth-child(4) {
    grid-area: pic4;
  }

  div:nth-child(5) {
    grid-area: pic5;
  }

  div:nth-child(6) {
    grid-area: pic6;
  }

  div:nth-child(7) {
    grid-area: pic7;
  }

  div:nth-child(8) {
    grid-area: pic8;
  }

  div:nth-child(9) {
    grid-area: pic9;
  }

  div:nth-child(10) {
    grid-area: pic10;
  }

  div:nth-child(11) {
    grid-area: pic11;
  }

  div:nth-child(12) {
    grid-area: pic12;
  }

  div:nth-child(13) {
    grid-area: pic13;
  }

  .text {
    padding: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: var(--ff-serif);
    font-size: clamp(16px, 23.4672px + 0.3704vw, 20px);
    font-weight: 400;
    line-height: 1;

    background-color: hsl(var(--clr-primary-500));
  }
}

@media screen and (max-width: 600px) {
  header {
    p {
      width: 95%;
      line-height: 18px;
    }
  }
  .gallery {
    margin: 10px 0;
    grid-template-areas:
      'pic2 pic2'
      'pic2 pic2'
      'pic2 pic2'
      'pic3 pic3'
      'pic3 pic3'
      'pic1 pic4'
      'pic1 pic4'
      'pic1 pic5'
      'pic1 pic5'
      'pic1 pic6'
      'pic1 pic6'
      'pic7 pic7'
      'pic7 pic7'
      'pic9 pic9'
      'pic9 pic9'
      'pic9 pic9'
      'pic10 pic8'
      'pic10 pic8'
      'pic11 pic8'
      'pic11 pic8'
      'pic12 pic8'
      'pic12 pic8'
      'pic13 pic13'
      'pic13 pic13'
      'pic13 pic13';
  }
}
</style>
